export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SKIP_VALIDATION = 'SKIP_VALIDATION';

export const VALIDATE_SESSION_REQUEST = 'VALIDATE_SESSION_REQUEST';
export const VALIDATE_SESSION_SUCCESS = 'VALIDATE_SESSION_SUCCESS';
export const VALIDATE_SESSION_FAILURE = 'VALIDATE_SESSION_FAILURE';

export const CREATE_SESSION_REQUEST = 'CREATE_SESSION_REQUEST';
export const CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS';
export const CREATE_SESSION_FAILURE = 'CREATE_SESSION_FAILURE';

export const EXTEND_SESSION_REQUEST = 'EXTEND_SESSION_REQUEST';
export const EXTEND_SESSION_SUCCESS = 'EXTEND_SESSION_SUCCESS';
export const EXTEND_SESSION_FAILURE = 'EXTEND_SESSION_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
